import React from 'react'
import { useForm } from 'react-hook-form'
import CrudCreate from '~/components/CrudCreate'
import IFirearmCaliber from '../interfaces/IFirearmCaliber'
import Layout from '~/components/Layout'

export default function Create() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
  } = useForm<IFirearmCaliber>()

  const fields = [{ name: 'name', type: 'string' }]

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'firearm-caliber'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Firearm caliber successfully created!'}
        title={'Add firearm caliber'}
        subheader={'Add firearm caliber'}
        setFormValue={setFormValue}
      />
    </Layout>
  )
}
